var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterWaves(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 627,
    height: 343,
    viewBox: "0 0 627 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.408 148.659C702.408 148.659 551.069 54.8012 448.137 98.7501C342.966 143.655 426.419 274.551 320.83 318.554C227.198 357.574 171.855 236.651 84.297 286.003C27.1943 318.188 -6.82877 407.913 -6.82877 407.913",
    stroke: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.044 118.235C693.044 118.235 541.705 24.3774 438.773 68.3263C333.601 113.232 417.055 244.127 311.466 288.13C217.833 327.151 162.491 206.228 74.9325 255.579C17.8298 287.764 -16.1933 377.489 -16.1933 377.489",
    stroke: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.97 85.5049C682.97 85.5049 531.631 -8.35256 428.699 35.5963C323.528 80.5016 406.981 211.397 301.392 255.4C207.76 294.421 152.417 173.498 64.859 222.849C7.75629 255.034 -26.2668 344.759 -26.2668 344.759",
    stroke: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWaves);
export default __webpack_public_path__ + "static/media/FooterWaves.b55e2924.svg";
export { ForwardRef as ReactComponent };